import { DebtModel } from './debt.model';
import { InvestmentHoldingModel } from './investment-holding.model';

/** All manual account types, one per form */
export enum ManualAccountType {
    // cash and banking
    Cash = 'cash',
    CheckingAccount = 'checkingAccount',
    SavingAccount = 'savingAccount',
    HighYieldSavingAccount = 'highYieldSavingAccount',
    OtherCashAndBanking = 'otherCashAndBanking',

    // retirements
    Education = 'education',
    CertificateOfDeposit = 'certificateOfDeposit',
    PrivateStock = 'privateStock',
    MutualFundsAndPublicStocks = 'mutualFundsAndPublicStocks',
    '401kAnd403b' = '401kAnd403b',
    Ira = 'ira',
    Pension = 'pension',
    Bonds = 'bonds',
    Cryptocurrency = 'cryptocurrency',
    OtherInvestmentsAndRetirement = 'otherInvestmentsAndRetirement',

    // property and assets
    RealEstate = 'realEstate',
    Vehicle = 'vehicle',
    CustomPropertyAndAsset = 'customPropertyAndAsset',

    // loans and debts
    Mortgage = 'mortgage',
    HomeEquityLoan = 'homeEquityLoan',
    StudentLoan = 'studentLoan',
    AutoLoan = 'autoLoan',
    PersonalLoan = 'personalLoan',
    CreditCardDebt = 'creditCardDebt',
    OtherDebt = 'otherDebt'
}

/** Manual account that wraps investmentHolding and debt */
export class ManualAccount {
    investmentHolding?: InvestmentHoldingModel;
    debt?: DebtModel;
}
